import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_MSIKEY as string,  // from Azure AD App Registration
    authority: "https://login.microsoftonline.com/common",
    redirectUri: window.location.origin,
  },
};

export const loginRequest = {
  scopes: [
    "User.Read",              // basic profile info (name, email, photo, id)
    "User.ReadBasic.All",     // read basic info of all users (optional, org-level)
    "email",                  // access to user's email address
    "openid",                 // required for OpenID Connect ID token
    "profile",                // get name, preferred username, etc.
    "offline_access",         // allows refresh tokens (stay signed in)
    // "Phone.Read",   
  ]
};
